import { h, Component, Prop } from "@stencil/core";
import { ApolloProviderConsumer } from "../../utils/apollo-client-state";
import { Declarations } from './declarations';
const Provider = ApolloProviderConsumer.Provider;
export class ApolloProviderComponent {
    constructor() {
        this.declarations = Declarations;
    }
    render() {
        return (h(Provider, { state: { client: this.client } },
            h("slot", null)));
    }
    static get is() { return "apollo-provider"; }
    static get properties() { return {
        "client": {
            "type": "unknown",
            "mutable": true,
            "complexType": {
                "original": "ApolloClient<any>",
                "resolved": "ApolloClient<any>",
                "references": {
                    "ApolloClient": {
                        "location": "import",
                        "path": "apollo-client"
                    }
                }
            },
            "required": false,
            "optional": false,
            "docs": {
                "tags": [],
                "text": ""
            }
        }
    }; }
}
